// src/contexts/SaveContext.js
import { createContext, useContext } from 'react';

export const SaveContext = createContext({
  onSave: () => {},
  isSaved: false
});

export const useSaveContext = () => useContext(SaveContext);